import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from '../common.service';
import { IEnvironmentVariables } from '../models/app-config.model';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
   keysValues: any;
  @Output() init: EventEmitter<any>;
  constructor(private httpClient: HttpClient, private _commonService:CommonService) { }

  loadConfig(){
    var origin = window.location.origin + window.location.pathname;
    if (this._commonService.isHybrid()) {
      origin = "./";
    }
    const url = origin + "assets/config/config.json";
    this.httpClient.get(url).subscribe(
      (variables:IEnvironmentVariables) => {
        this.keysValues = variables;
       let  keys = Object.keys(variables);
        keys.forEach(key => {
          environment[key] = variables[key];
        });

        this.init.emit(true);
      }
    );
  }

}
